import { cn } from '~/shadcn/lib/utils'

export function Text({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('text-md leading-normal', className)} {...props} />
}
